import React, { useEffect, useState, useCallback } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Input,
  Label,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../redux-toolkit/store";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";
import CardHeaderSpan from "../../Utils/CommonComponents/CardHeaderSpan";
import CommonTableNew, {
  HeadDataItem,
} from "../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import TreeModel from "../Dashboards/Attendance/AttendanceTable/TreeModel";
import { getFilteredPositionIds } from "../../db/DexieServises";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import FeatherIconCom from "../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
interface TerritoryItem {
  TerritoryId: number | string;
  TerritoryName: string;
}
const DailyEffortReport = () => {
  const getInitialDates = () => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const formatDate = (date: Date) => {
      const d = String(date.getDate()).padStart(2, "0");
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const y = date.getFullYear();
      return `${y}-${m}-${d}`;
    };
    return { start: formatDate(firstDay), end: formatDate(lastDay) };
  };

  const [dateRange, setDateRange] = useState<{ start: string; end: string }>(
    getInitialDates(),
  );
  const unitId = useSelector((state: RootState) => state.orgUnit.id);
  const serverUrl = localStorage.getItem("serverUrl");
  const [dailyEffortReportData, setDailyEffortReportData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [territoryList, setTerritoryList] = useState<TerritoryItem[]>([]);
  const [selectedTerritoryId, setSelectedTerritoryId] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");

  // console.log("=======selectedTerritoryId========", selectedTerritoryId);
  console.log("=======dailyEffortReportData========", dailyEffortReportData);
  console.log("=======unitId========", unitId);

  useEffect(() => {
    const getDailyEffortReport = async () => {
      try {
        if (!serverUrl || !dateRange.start || !dateRange.end || !unitId) return;
        setLoading(true);
        const params = {
          start_date: dateRange.start,
          end_date: dateRange.end,
          org_unit_id: unitId,
        };
        const url = `${serverUrl}${API.dailyEffortReport}`;
        const { status, data: responseData } = await getData(url, true, params);
        if (status === 200 && responseData?.data) {
          const actualData = Array.isArray(responseData.data)
            ? responseData.data
            : responseData.data.data || [];
          setDailyEffortReportData(actualData);
        } else {
          setDailyEffortReportData([]);
        }
      } catch (err) {
        console.error("Error fetching daily effort report data:", err);
        setDailyEffortReportData([]);
      } finally {
        setLoading(false);
      }
    };
    getDailyEffortReport();
  }, [serverUrl, dateRange.start, dateRange.end, unitId]);
  useEffect(() => {
    const getactiveVacantTerritories = async () => {
      try {
        if (!serverUrl) return;
        const url = `${serverUrl}${API.activeVacantTerritories}`;
        const { status, data: responseData } = await getData(url, true);
        if (status === 200 && responseData?.data) {
          setTerritoryList(responseData.data.activeTerritories);
        } else {
          setTerritoryList([]);
        }
      } catch (err) {
        console.error("Error fetching active vacant territories data:", err);
        setTerritoryList([]);
      }
    };
    getactiveVacantTerritories();
  }, [serverUrl]);
  const reportList = Array.isArray(dailyEffortReportData)
    ? dailyEffortReportData
    : [];

  const tableData = React.useMemo(() => {
    const baseDataManual = reportList.map((item: any) => {
      const dateStr = item.AttendanceDate;
      const updatedDateRaw = item.UpdatedAt || item.updated_at;

      let dayName = "-";
      if (dateStr) {
        const dateObj = new Date(dateStr);
        if (!isNaN(dateObj.getTime())) {
          dayName = dateObj.toLocaleDateString("en-US", { weekday: "long" });
        }
      }

      let submitDateFormatted = "-";
      if (updatedDateRaw) {
        const d = new Date(updatedDateRaw);
        if (!isNaN(d.getTime())) {
          submitDateFormatted = d.toLocaleDateString("en-GB");
        }
      }

      let submitDaysValue: number | string = "-";
      if (dateStr && updatedDateRaw) {
        const startDate = new Date(dateStr);
        const endDate = new Date(updatedDateRaw);

        if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
          const start = new Date(
            startDate.getFullYear(),
            startDate.getMonth(),
            startDate.getDate(),
          );
          const end = new Date(
            endDate.getFullYear(),
            endDate.getMonth(),
            endDate.getDate(),
          );

          const diffTime = end.getTime() - start.getTime();
          const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24)) + 1;
          submitDaysValue = diffDays;
        }
      }

      return {
        ...item,
        EmployeeName: `${item.FirstName || ""} ${item.LastName || ""}`.trim(),
        AttendanceDay: dayName,
        SubmitDays: submitDaysValue,
        SubmitDate: submitDateFormatted,
      };
    });

    let filtered = baseDataManual;
    if (searchTerm.trim()) {
      const lowerSearchTerm = searchTerm.toLowerCase();
      filtered = baseDataManual.filter(
        (item: any) =>
          item.EmployeeName.toLowerCase().includes(lowerSearchTerm) ||
          item.Designation.toLowerCase().includes(lowerSearchTerm) ||
          (item.EmployeeCode &&
            item.EmployeeCode.toString()
              .toLowerCase()
              .includes(lowerSearchTerm)),
      );
    }

    return filtered;
  }, [reportList, searchTerm]);

  const headData: HeadDataItem[] = React.useMemo(() => {
    if (reportList.length === 0) return [];

    const firstItem = reportList[0];
    const excludedKeys = [
      "CompanyId",
      "OrgUnitId",
      "OrderTotal",
      "AttendanceStatus",
      "UpdatedAt",
      "updated_at",
      "FirstName",
      "LastName",
      "AttendanceDate",
      "ActualBeatNamesWithCount",
      "EmployeeCode",
      "start_town",
      "end_town",
    ];

    const headers: HeadDataItem[] = [
      {
        id: "date",
        head: "Date",
        key: "AttendanceDate",
        sortKey: "AttendanceDate",
      },
      {
        id: "day",
        head: "Day",
        key: "AttendanceDay",
        sortKey: "AttendanceDay",
      },
      {
        id: "employeeId",
        head: "Employee ID",
        key: "EmployeeCode",
        sortKey: "EmployeeCode",
      },
      {
        id: "name",
        head: "Employee Name",
        key: "EmployeeName",
        sortKey: "EmployeeName",
      },
      {
        id: "locationPlanned",
        head: "Location Planned",
        key: "start_town",
        sortKey: "start_town",
      },
      {
        id: "locationWorked",
        head: "Location Worked",
        key: "ActualBeatNamesWithCount",
        sortKey: "ActualBeatNamesWithCount",
      },
      {
        id: "submitDate",
        head: "Submit Date",
        key: "SubmitDate",
        sortKey: "SubmitDate",
      },
      {
        id: "submitDay",
        head: "Submit Day",
        key: "SubmitDays",
        sortKey: "SubmitDays",
      },
    ];

    const headerMapping: Record<string, string> = {
      // Common mappings can be put here if needed for any dynamic columns
    };

    Object.keys(firstItem).forEach((key) => {
      if (!excludedKeys.includes(key)) {
        headers.push({
          id: key,
          head: headerMapping[key] || key,
          key: key,
          sortKey: key,
        });
      }
    });

    return headers;
  }, [reportList]);

  const handleExportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Daily Effort Report");

    const columns: Partial<ExcelJS.Column>[] = headData.map((head) => {
      const headerText = typeof head.head === "string" ? head.head : head.key;
      return {
        header: headerText,
        key: head.key,
        width: headerText === "Employee Name" ? 25 : 15,
      };
    });

    worksheet.columns = columns as ExcelJS.Column[];

    const headerRow = worksheet.getRow(1);
    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF4472C4" },
    };
    headerRow.alignment = { horizontal: "center", vertical: "middle" };

    tableData.forEach((row) => {
      const rowData: Record<string, any> = {};
      headData.forEach((head) => {
        rowData[head.key] = (row as any)[head.key] ?? "-";
      });

      const dataRow = worksheet.addRow(rowData);

      dataRow.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };

        const value = cell.value ? String(cell.value).toUpperCase() : "";
        if (value === "YES" || value === "PRESENT") {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFC6EFCE" },
          };
          cell.font = { color: { argb: "FF006100" } };
        } else if (value === "NO" || value === "ABSENT") {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFC7CE" },
          };
          cell.font = { color: { argb: "FF9C0006" } };
        }
      });
    });

    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(
      blob,
      `DailyEffortReport_${new Date().toISOString().split("T")[0]}.xlsx`,
    );
  };

  return (
    <div className="page-body p-2">
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <div>
                <CardHeaderSpan
                  headingClassName="pb-0"
                  back={true}
                  heading="Daily Effort Report"
                />
              </div>
              <div className="row px-3 py-1 mb-3 mt-2 align-items-center justify-content-between">
                <div className="col-md-6 d-flex align-items-center gap-3 ">
                  <Input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search by Employee Name or ID"
                    className="form-control"
                    style={{ maxWidth: "250px" }}
                  />
                </div>

                <div className="col-md-6 d-flex justify-content-end gap-3 ">
                  <div className="d-flex align-items-center gap-2">
                    <Label className="mb-0" style={{ fontSize: 13 }}>
                      From:
                    </Label>
                    <Input
                      type="date"
                      value={dateRange.start}
                      onChange={(e) =>
                        setDateRange((prev) => ({
                          ...prev,
                          start: e.target.value,
                        }))
                      }
                      style={{ maxWidth: "150px" }}
                      bsSize="sm"
                    />
                    <Label className="mb-0" style={{ fontSize: 13 }}>
                      To:
                    </Label>
                    <Input
                      type="date"
                      value={dateRange.end}
                      onChange={(e) =>
                        setDateRange((prev) => ({
                          ...prev,
                          end: e.target.value,
                        }))
                      }
                      style={{ maxWidth: "150px" }}
                      bsSize="sm"
                    />
                    <button
                      className="btn btn-sm btn-primary align-items-center d-flex "
                      onClick={handleExportToExcel}
                    >
                      <FeatherIconCom
                        iconName={"Download"}
                        size={14}
                        className="text-light"
                      />
                      <span className="px-2" style={{ fontSize: 14 }}>
                        Export
                      </span>
                    </button>
                  </div>
                </div>
              </div>
              <CardBody className="pt-0">
                {loading ? (
                  <div className="text-center py-5">
                    <Spinner color="primary" />
                    <div className="mt-2">Loading data...</div>
                  </div>
                ) : (
                  <CommonTableNew
                    tableClass="table-bordered"
                    hover
                    headClass="table"
                    headData={headData}
                    data={tableData}
                    renderRow={(row, rowIndex) => (
                      <tr key={rowIndex}>
                        {headData.map((c) => (
                          <td key={c.key}>{(row as any)[c.key] ?? "-"}</td>
                        ))}
                      </tr>
                    )}
                    initialRows={10}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DailyEffortReport;
